(() => {
  const allowedParameters = [
    "product_code",
    "product_name",
    "product_handle",
    "product_category",
    "collection_handle",
    "collection_title",
    "geo_page",
    "source_page",
    "form_location",
    "utm_source",
    "utm_medium",
    "utm_campaign",
    "utm_term",
    "utm_content",
  ];

  const emitEvent = (name, parameters = {}) => {
    const payload = {
      event_category: "b2b_inquiry",
      page_path: window.location.pathname,
      ...parameters,
    };
    if (typeof window.gtag === "function") {
      window.gtag("event", name, payload);
      return;
    }
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: name, ...payload });
  };

  const safeStorage = {
    get(storage, key) {
      try {
        return storage.getItem(key) || "";
      } catch {
        return "";
      }
    },
    set(storage, key, value) {
      try {
        storage.setItem(key, value);
      } catch {
        return;
      }
    },
  };

  const attributionValue = (parameters) => {
    const values = {};
    ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content"].forEach((key) => {
      const value = parameters.get(key);
      if (value) values[key] = value;
    });
    if (document.referrer) values.referrer = document.referrer;
    values.landing_page = `${window.location.pathname}${window.location.search}`;
    return JSON.stringify(values);
  };

  const captureAttribution = (parameters) => {
    const firstTouchKey = "lehuo_first_touch";
    const currentTouchKey = "lehuo_current_touch";
    const captured = attributionValue(parameters);
    const existingFirstTouch = safeStorage.get(window.localStorage, firstTouchKey);
    const existingCurrentTouch = safeStorage.get(window.sessionStorage, currentTouchKey);
    if (!existingFirstTouch) {
      safeStorage.set(window.localStorage, firstTouchKey, captured);
    }
    const hasCampaignParameters = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content"].some(
      (key) => parameters.get(key),
    );
    if (hasCampaignParameters || !existingCurrentTouch) {
      safeStorage.set(window.sessionStorage, currentTouchKey, captured);
    }
  };

  const setupForm = (form, parameters) => {
    form.querySelectorAll("[data-lehuo-param]").forEach((field) => {
      const key = field.dataset.lehuoParam;
      const value = parameters.get(key);
      if (value) field.value = value;
    });

    const sourceField = form.querySelector('[data-lehuo-param="source_page"]');
    const locationField = form.querySelector('[data-lehuo-param="form_location"]');
    if (sourceField && !sourceField.value) {
      sourceField.value = form.dataset.defaultSourcePage || window.location.pathname;
    }
    if (locationField && !locationField.value) {
      locationField.value = form.dataset.defaultFormLocation || "contact_page";
    }

    const productField = form.querySelector("[data-lehuo-product-field]");
    if (productField && !productField.value) {
      productField.value =
        parameters.get("product_name") ||
        parameters.get("product_code") ||
        parameters.get("collection_title") ||
        parameters.get("geo_page") ||
        "";
    }

    const firstTouchKey = "lehuo_first_touch";
    const currentTouchKey = "lehuo_current_touch";

    const firstTouchField = form.querySelector("[data-lehuo-first-touch]");
    const currentTouchField = form.querySelector("[data-lehuo-current-touch]");
    if (firstTouchField) {
      firstTouchField.value = safeStorage.get(window.localStorage, firstTouchKey);
    }
    if (currentTouchField) {
      currentTouchField.value = safeStorage.get(window.sessionStorage, currentTouchKey);
    }

    emitEvent("quote_form_view", {
      source_page: sourceField?.value || window.location.pathname,
      form_location: locationField?.value || "contact_page",
    });

    let started = false;
    const startHandler = () => {
      if (started) return;
      started = true;
      emitEvent("quote_start", {
        source_page: sourceField?.value || window.location.pathname,
        form_location: locationField?.value || "contact_page",
      });
    };
    form.addEventListener("focusin", startHandler, { once: true });
    form.addEventListener("input", startHandler, { once: true });

    form.addEventListener("submit", () => {
      const submit = form.querySelector("[data-lehuo-submit]");
      if (!submit) return;
      submit.disabled = true;
      submit.setAttribute("aria-busy", "true");
      window.setTimeout(() => {
        submit.disabled = false;
        submit.removeAttribute("aria-busy");
      }, 10000);
    });
  };

  const setup = () => {
    const parameters = new URLSearchParams(window.location.search);
    captureAttribution(parameters);
    document.querySelectorAll("[data-lehuo-inquiry-form]").forEach((form) => setupForm(form, parameters));

    document.querySelectorAll("[data-lehuo-quote]").forEach((link) => {
      link.addEventListener("click", () => {
        const target = new URL(link.href, window.location.origin);
        emitEvent("quote_link_click", {
          source_page: target.searchParams.get("source_page") || window.location.pathname,
          form_location: target.searchParams.get("form_location") || "unknown",
        });
      });
    });

    const success = document.querySelector("[data-lehuo-inquiry-success='true']");
    if (!success) return;
    const successKey = `lehuo_quote_success:${window.location.pathname}:${parameters.get("contact_posted") || "posted"}`;
    if (safeStorage.get(window.sessionStorage, successKey)) return;
    safeStorage.set(window.sessionStorage, successKey, "1");
    emitEvent("quote_submit", { form_location: parameters.get("form_location") || "contact_page" });
    emitEvent("generate_lead", { form_location: parameters.get("form_location") || "contact_page" });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", setup, { once: true });
  } else {
    setup();
  }
})();
